import React, { useCallback } from "react";
import ReactMarkdown from "react-markdown";
import remarkEmoji from "remark-emoji";
import rehypeRaw from "rehype-raw";
import useUserPilot from "hooks/useUserPilot";

function HtmlSetting({ setting }) {
  const Userpilot = useUserPilot();

  const customAnchorTag = useCallback(({ href, children, ...props }) => {
    const userPilotTriggerMatch = href.match(/userpilot\.trigger\('(.+?)'\)/);
    if (userPilotTriggerMatch) {
      href = "";
      props.onClick = (event) => {
        event.preventDefault();
        Userpilot.trigger(userPilotTriggerMatch[1]);
      };
    }

    return (
      <a
        href={href}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {children}
      </a>
    );
  }, []);

  return (
    <ReactMarkdown
      remarkPlugins={[remarkEmoji]}
      rehypePlugins={[rehypeRaw]}
      components={{
        a: customAnchorTag,
      }}
    >
      {setting.en_field_label || ""}
    </ReactMarkdown>
  );
}

export default HtmlSetting;
